export const accList = [
    'download',
    'search',
    'risk',
    'company_settings',
    'company_users',
  ];